module.exports = __webpack_public_path__ + "assets/img/znwd_icon.dc75bccd.png";